import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function ProcessSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    number: '01',
    title: t('process.step1.title'),
    description: t('process.step1.desc')
  }, {
    number: '02',
    title: t('process.step2.title'),
    description: t('process.step2.desc')
  }, {
    number: '03',
    title: t('process.step3.title'),
    description: t('process.step3.desc')
  }, {
    number: '04',
    title: t('process.step4.title'),
    description: t('process.step4.desc')
  }];
  return <section className="py-28 lg:py-36 px-6 bg-[#FAFAF8]" data-id="element-208">
      <div className="max-w-7xl mx-auto" data-id="element-209">
        <div className="text-center mb-20" data-id="element-210">
          <h2 className="font-serif text-5xl lg:text-6xl mb-6 tracking-tight font-light" data-id="element-211">
            {t('process.title')}
          </h2>
          <p className="text-[#1A1A1A]/60 font-light text-base max-w-2xl mx-auto leading-relaxed" data-id="element-212">
            {t('process.intro')}
          </p>
        </div>

        {/* Grid of Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-213">
          {steps.map((step, index) => <div key={index} className="bg-white border border-[#1A1A1A]/8 p-8 transition-all duration-300 hover:border-[#B8956C]/40 hover:shadow-lg group" data-id="element-214">
              {/* Number */}
              <div className="mb-6" data-id="element-215">
                <span className="font-serif text-5xl text-[#B8956C] font-light block" data-id="element-216">
                  {step.number}
                </span>
              </div>

              {/* Divider */}
              <div className="w-12 h-[1px] bg-[#B8956C]/30 mb-6 group-hover:w-20 transition-all duration-300" data-id="element-217"></div>

              {/* Title */}
              <h3 className="font-serif text-xl mb-4 tracking-wide font-medium leading-tight" data-id="element-218">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-[#1A1A1A]/60 font-light text-sm leading-relaxed" data-id="element-219">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}